<template>
    <Layout>
        <PageHeader :title="title" :items="items"></PageHeader>
        <div class="row" id="series">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center mb-4">
                <div class="col-md-4">
                  <div class="form-inline navbar-search">
                    <div class="input-group">
                      <input v-on:keyup="search" name="title" class="form-control bg-light border-0 small"
                        placeholder="Search Title" aria-label="Search" aria-describedby="basic-addon2" value=""
                        v-model="filter" />
                      <div class="input-group-append">
                        <button class="btn btn-search" @click="searchFor">
                          <i class="fas fa-search fa-sm"> </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="all-tabs">
                    <div class="d-flex flex-wrap justify-content-end align-items-start" style="gap: 12px">
                      <div>
                        <label class="d-block font-weight-bold mb-1" style="font-size: 14px">Product :</label>
                        <b-form-select
                          style="width: 150px; height: 40px"
                          v-model="selected_product"
                          :options="filter_product_options"
                          @change="() => { currentPage = 1; fetchData(); }"
                        >
                        </b-form-select>
                      </div>

                      <div>
                        <label class="d-block font-weight-bold mb-1" style="font-size: 14px">Filter Expire In :</label>
                        <b-form-select
                          style="width: 130px; height: 40px"
                          v-model="selected_plans"
                          :options="filter_plan_options"
                          @change="onPlanChange"
                        >
                        </b-form-select>
                      </div>

                      <div v-if="selected_plans === 'custom'">
                        <label class="d-block font-weight-bold mb-1" style="font-size: 15px">No. of days :</label>
                        <div class="d-flex align-items-center">
                          <b-form-input
                            type="number"
                            min="1"
                            placeholder="No. of days"
                            v-model="custom_days"
                            style="width: 110px; height: 40px"
                          >
                          </b-form-input>
                          <b-button
                            variant="primary"
                            class="ml-2"
                            style="height: 40px"
                            @click="() => { currentPage = 1; fetchData(); }"
                          >
                            Apply
                          </b-button>
                        </div>
                      </div>

                      <div>
                        <label class="d-block font-weight-bold mb-1" style="font-size: 14px">State :</label>
                        <multiselect
                          style="width: 180px"
                          v-model="selected_state"
                          :options="state_list"
                          track-by="state"
                          label="state"
                          :multiple="false"
                          placeholder="Select State"
                          :allow-empty="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          @input="onStateChange"
                        ></multiselect>
                      </div>

                      <div>
                        <label class="d-block font-weight-bold mb-1" style="font-size: 14px">City :</label>
                        <multiselect
                          style="width: 180px"
                          v-model="selected_city"
                          :options="city_list"
                          track-by="city"
                          label="city"
                          :multiple="false"
                          placeholder="Select City"
                          :allow-empty="false"
                          select-label=""
                          deselect-label=""
                          selected-label=""
                          :disabled="selected_state.state === 'All'"
                          @input="onCityChange"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData.data"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive
                  class="table-bordered table-hover"
                >
                  <template v-slot:cell(fname)="row">
                    {{ row.item.fname }} {{ row.item.lname }}
                  </template>
                  <template v-slot:cell(city)="row">
                    {{ row.item.city || "-" }}
                  </template>
                  <template v-slot:cell(state)="row">
                    {{ row.item.state || "-" }}
                  </template>
              <template v-slot:cell(product_name)="row">
                <span class="product-name-text">{{ row.item.product_name }}</span>
                  <span
                    v-if="row.item.plan_name && (row.item.product_name || '').toLowerCase().includes('clinic')"
                    class="plan-name-badge"
                  >
                    {{ row.item.plan_name }}
                  </span>
                  <div v-if="isRowExpired(row.item)" class="text-danger small font-weight-bold">
                    Expired
                  </div>
                  </template>
                  <template v-slot:cell(start_date)="row">
                    {{ productDate(row.item, "start") }}
                  </template>
                  <template v-slot:cell(end_date)="row">
                    {{ productDate(row.item, "end") }}
                  </template>
                  <template v-slot:cell(dashboard)="row">
                    <router-link
                      v-if="(row.item.product_name || '').toLowerCase().includes('gmb')"
                      :to="{
                        name: 'gmb',
                        query: { location_id: row.item.location_id },
                      }"
                    >
                      <b-button variant="outline-primary" class="btn-sm">
                        GMB Dashboard
                      </b-button>
                    </router-link>
                    <router-link
                      v-else-if="row.item.my_clinic || (row.item.product_name || '').toLowerCase().includes('clinic')"
                      :to="{
                        name: 'My Clinic',
                        query: { search: row.item.mobile_number },
                      }"
                    >
                      <b-button variant="outline-primary" class="btn-sm">
                        My Clinic Dashboard
                      </b-button>
                    </router-link>
                    <router-link
                      v-else-if="(row.item.product_name || '').toLowerCase().includes('saarthi')"
                      :to="{
                        name: 'Health Saarthi',
                        query: { search: row.item.mobile_number },
                      }"
                    >
                      <b-button variant="outline-primary" class="btn-sm">
                        Health Saarthi Dashboard
                      </b-button>
                    </router-link>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:cell(renew)="row">
                    <b-button
                      v-if="(row.item.my_clinic || (row.item.product_name || '').toLowerCase().includes('clinic')) && isRenewEligible(row.item)"
                      variant="success"
                      class="btn-sm"
                      @click="openRenew(row.item)"
                    >
                      Renew
                    </b-button>
                    <b-button
                      v-else-if="((row.item.product_name || '').toLowerCase().includes('gmb') || (row.item.product_name || '').toLowerCase().includes('saarthi')) && isProductRenewEligible(row.item)"
                      variant="success"
                      class="btn-sm"
                      @click="openProductRenew(row.item)"
                    >
                      Renew
                    </b-button>
                    <span v-else>-</span>
                  </template>
                  <!-- <template v-slot:cell(product_info)="row">
                    <b-button
                      @click="openModal(row.item)"
                      class="btn btn-sm btn-primary"
                      >Product Info</b-button
                    >
                  </template> -->
                </b-table>
              </div>
              <template v-if="tableData.pagination.totalPages > 1">
                <div class="data_paginate">
                  <div class="d-flex justify-content-end">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="tableData.pagination.total"
                      :per-page="tableData.pagination.size"
                      first-number
                      last-number
                    ></b-pagination>
                  </div>

                  <div class="form-inline mt-2">
                    <span class="mr-2">Go to page:</span>
                    <b-form-input v-model="pageNo" class="in-width"></b-form-input>
                    <button class="btn btn-search ml-2" @click="filterPage">
                      Go
                    </button>
                  </div>

                </div>
              </template>
            </div>
          </div>
          <b-modal
            v-model="showModal"
            title="Product Information"
            centered
            hide-header-close
            no-close-on-backdrop
            ok-only
            ok-title="Close"
            size="lg"
          >
            <div class="mb-3">
              <p>
                <strong>Doctor Name:</strong>
                {{ form.fname }} {{ form.lname }}
              </p>

              <p>
                <strong>Mobile Number:</strong>
                {{ form.mobile_number }}
              </p>

              <p>
                <strong>MRN:</strong>
                {{ form.medisage_ref_number }}
              </p>
            </div>

            <b-table
              :items="productInfo"
              :fields="product_fields"
              bordered
              small
            >
              <!-- <template #cell(status)="data">
                <b-badge :variant="data.item.status ? 'success' : 'danger'">
                  {{ data.item.status ? 'Active' : 'Inactive' }}
                </b-badge>
              </template> -->
            </b-table>
          </b-modal>

          <b-modal
            v-model="showRenewModal"
            title="Renew My Clinic Subscription"
            centered
            hide-header-close
            no-close-on-backdrop
            size="lg"
            ok-title="Renew"
            cancel-title="Close"
            @ok="handleRenew"
          >
            <div class="mb-3">
              <p class="mb-1">
                <strong>Doctor Name:</strong>
                {{ renewItem.fname }} {{ renewItem.lname }}
              </p>
              <p class="mb-1">
                <strong>Mobile Number:</strong>
                {{ renewItem.mobile_number }}
              </p>
              <p class="mb-0">
                <strong>Current Plan:</strong>
                {{ renewItem.plan_name || "-" }}
              </p>
            </div>

            <div class="mb-3">
              <label class="d-block font-weight-bold mb-2">Select Plan</label>
              <b-button
                v-for="p in renew_plans"
                :key="p.value"
                :variant="renewForm.plan === p.value ? 'primary' : 'outline-primary'"
                class="mr-2 mb-2"
                @click="selectRenewPlan(p)"
              >
                {{ p.text }}
              </b-button>
            </div>

            <div class="mb-3">
              <label class="d-block font-weight-bold mb-2">Select Duration</label>
              <b-button
                v-for="m in renew_durations"
                :key="m"
                :variant="renewForm.months === m ? 'success' : 'outline-success'"
                class="mr-2 mb-2"
                @click="selectRenewDuration(m)"
              >
                {{ m }} Months
              </b-button>
            </div>

            <div v-if="renewForm.start_date" class="renew-dates p-3">
              <p class="mb-1">
                <strong>Start Date:</strong> {{ renewForm.start_date }}
              </p>
              <p class="mb-0">
                <strong>End Date:</strong> {{ renewForm.end_date }}
              </p>
            </div>
          </b-modal>

          <b-modal
            v-model="showProductRenewModal"
            title="Renew Subscription"
            centered
            hide-header-close
            no-close-on-backdrop
            size="lg"
            ok-title="Renew"
            cancel-title="Close"
            @ok="handleProductRenew"
          >
            <div class="mb-3">
              <p class="mb-1">
                <strong>Doctor Name:</strong>
                {{ productRenewItem.fname }} {{ productRenewItem.lname }}
              </p>
              <p class="mb-1">
                <strong>Mobile Number:</strong>
                {{ productRenewItem.mobile_number }}
              </p>
              <p class="mb-0">
                <strong>Product:</strong>
                {{ productRenewItem.product_name }}
              </p>
            </div>

            <div class="mb-3">
              <label class="d-block font-weight-bold mb-2">Select Duration</label>
              <b-button
                v-for="m in renew_durations"
                :key="m"
                :variant="productRenewForm.months === m ? 'success' : 'outline-success'"
                class="mr-2 mb-2"
                @click="selectProductRenewDuration(m)"
              >
                {{ m }} Months
              </b-button>
            </div>

            <div v-if="productRenewForm.start_date" class="renew-dates p-3">
              <p class="mb-1">
                <strong>Start Date:</strong> {{ productRenewForm.start_date }}
              </p>
              <p class="mb-0">
                <strong>End Date:</strong> {{ productRenewForm.end_date }}
              </p>
            </div>
          </b-modal>
        </div>
      </div>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import wowDoctorMixin from "../../../mixins/ModuleJs/product-subscription";
import Multiselect from "vue-multiselect";

export default {
    data() {
      return {
        title: "Subscription List",
        sortBy: "_id",
        sortDesc: true,
        items: [
          {
            text: "Home",
            href: "/",
          },
          {
            text: "List",
          },
        ],
      };
    },
    mixins: [wowDoctorMixin, MixinRequest],
    components: {
      Layout,
      PageHeader,
      Multiselect,
    },
  };
</script>

<style scoped>
  .product-name-text {
    font-weight: 700;
    color: #2d3a8c;
  }

  .plan-name-badge {
    display: inline-block;
    margin-left: 6px;
    padding: 2px 8px;
    font-size: 0.75rem;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    border-radius: 12px;
  }

  .renew-dates {
    background: #f4f7ff;
    border: 1px solid #dbe4fd;
    border-radius: 10px;
  }

  /* keep the City select non-interactive when disabled, but without the grey look */
  ::v-deep .multiselect--disabled {
    /* background: #fff; */
    opacity: 1;
  }

  ::v-deep .multiselect--disabled .multiselect__tags,
  ::v-deep .multiselect--disabled .multiselect__single,
  ::v-deep .multiselect--disabled .multiselect__select {
    background: #fff;
  }
</style>